<template>
  <div class="registerCardStyle">
    <UserBase :loginLink="false">
      <template #default>
        <v-row no-gutters class="py-3" justify="center" align-content="center">
          <v-col cols="9">
            <p class="primary--text text-center font-weight-bold text-h6">
              {{ $t('common.common_sent-inquirey') }}
            </p>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="9">
            <p class="description">
              {{ $t('common.common_reply-after-confirming') }}
            </p>
          </v-col>
        </v-row>
      </template>
    </UserBase>
  </div>
</template>
<script>
import { UserBase } from '@/components/layouts'

export default {
  components: {
    UserBase
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .description {
    color: #333;
    line-height: 25px;
  }
  .terms {
    font-size: 12px !important;
  }
}
</style>
